// extracted by mini-css-extract-plugin
module.exports = {"box":"FJPlaceholder_box__1SXeH","active":"FJPlaceholder_active__3oj1j"};